import type { Coach } from "@/lib/types";
import { useTranslations } from "@/i18n/LocaleProvider";
import DatePicker from "@/components/DatePicker";

export default function SlotStep({
  selectedDate,
  onDateChange,
  maxDate,
  loading,
  slots,
  selectedSlot,
  onSelectSlot,
  coach,
  onContinue,
}: {
  selectedDate: string;
  onDateChange: (date: string) => void;
  maxDate: string | undefined;
  loading: boolean;
  slots: number[];
  selectedSlot: number | null;
  onSelectSlot: (slot: number) => void;
  coach: Coach;
  onContinue: () => void;
}) {
  const { t } = useTranslations();
  return (
    <div className="mt-3 space-y-2.5 sm:mt-4 sm:space-y-3">
      <div className="surface-card space-y-2.5 p-4 sm:space-y-3 sm:p-5">
        <div className="flex justify-center sm:justify-start">
          <DatePicker
            value={selectedDate}
            onChange={onDateChange}
            min={new Date().toISOString().slice(0, 10)}
            max={maxDate}
          />
        </div>

        {loading && <p className="text-sm text-muted">{t("book.slot.checking")}</p>}
        {!loading && slots.length === 0 && (
          <p className="text-sm text-muted">{t("book.slot.noSlots")}</p>
        )}

        {!loading && slots.length > 0 && (
          <div className="grid grid-cols-3 gap-1.5 border-t border-foreground/8 pt-2.5 sm:grid-cols-4 sm:gap-2 sm:pt-3">
            {slots.map((slot) => (
              <button
                key={slot}
                onClick={() => onSelectSlot(slot)}
                className={`whitespace-nowrap rounded-lg border px-2 py-1.5 text-xs font-medium transition sm:py-2 ${
                  selectedSlot === slot
                    ? "border-accent bg-accent text-accent-foreground"
                    : "border-foreground/15 hover:border-accent"
                }`}
              >
                {new Intl.DateTimeFormat("en-IN", {
                  hour: "numeric",
                  minute: "2-digit",
                  timeZone: coach.timezone,
                }).format(new Date(slot))}
              </button>
            ))}
          </div>
        )}
      </div>

      {selectedSlot && (
        <div className="flex justify-center">
          <button
            onClick={onContinue}
            className="rounded-xl bg-accent px-8 py-2 font-semibold text-accent-foreground"
          >
            {t("book.slot.continue")}
          </button>
        </div>
      )}
    </div>
  );
}
